import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import bannerBg from "../../../assets/images/home/home-banner-bg.svg";
import bannerImg from "../../../assets/images/home/banner-image.svg";
import overview from "../../../assets/images/home/overview.svg";
import file from "../../../assets/images/home/file.svg";
import Inbox from "../../../components/kpi/Inbox";
import { useSelector, useDispatch } from "react-redux";
import cssVariables from "../../../theme/cssVariables";
import React, { useEffect } from "react";
import { fetchHomeDashBoard } from "../../../actions/home";
import { ReactComponent as InfoIcon } from "../../../assets/icons/info.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-month.svg";
import homeService from "../../../services/home.service";
import DashboardMyGoals from "../../../components/kpi/DashboardMyGoals";
import DashboardMyCompetencies from "../../../components/DashboardMyCompetencies";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { ReactComponent as DraftIcon } from "../../../assets/images/iconStatus/draft.svg";
import { ReactComponent as PendingIcon } from "../../../assets/images/iconStatus/pending.svg";
import { ReactComponent as ApprovedIcon } from "../../../assets/images/iconStatus/approved.svg";
import { ReactComponent as CancelIcon1 } from "../../../assets/images/iconStatus/cancel.svg";
import { ReactComponent as RejectIcon } from "../../../assets/images/iconStatus/reject.svg";
import iconNext from "../../../assets/images/news/icon-arrow-next.svg";
import iconCore from "../../../assets/images/iconCore.svg";
import iconFunctional from "../../../assets/images/iconFunctional.svg";
import myGoals from "../../../icons/myGoals.png";
import myCompetencies from "../../../icons/myCompetencies.png";
import GoalsStatusWithEmpty from "../../../components/kpi/GoalsStatusWithEmpty";
import MyAchievements from "../../../components/kpi/MyAchievementsCustom";
import { ReactComponent as KpiArrow } from "../../../icons/kpiArrow.svg";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { makeStyles, styled } from "@mui/styles";
import { getGoalList } from "../../../actions/mygoal";
import 'moment/locale/th'
import moment from "moment";
import competencyService from "../../../services/competency.service";
import Announcement from "../Announcement";
import * as Util from "../../../services/global.service";
import evaluateService from "../../../services/evaluate.service";
import fileBrowser from "../../../icons/file-browser.svg";

import EvaluationRatio from "../../../components/baseComponent/EvaluationRatio";

import {
  getKpiFormList,
  getAchievementSummary,
  getAchievementList,
} from "../../../actions/achievement";
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { find } from 'lodash';
// swiper core styles
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'
// modules styles
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'
// import required modules
SwiperCore.use([Navigation, Pagination]);

const useStyles = makeStyles({
  media: {
    height: 200,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  blueBg: {
    background: "#6694CC",
  },
  purpleBg: {
    background: "#7580BD",
  },
  customCardSize: {
    height: 380,
  },
  cardContentSize: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    alignItems: "center",
    height: "calc(100% - 130px)",
  },
  styleText: {
    textDecoration: "underline",
    fontWeight: "500",
  },
  styleScroll: {
    color: "#5DA196",
    paddingLeft: "30px",
    paddingRight: "20px",
  },
  toggleBtnRoot: {
    background: `transparent !important`,
    color: "#6B6B6B !important",
    width: "320px",
    border: "none !important",
  },
  toggleBtnSelected: {
    background: `${cssVariables.color.primary}!important`,
    color: "#fff!important",
  },
  processBgGoals: {
    background: "#8DADC2  !important",
  },

  processBgRubric: {
    background: "#85AEB0 !important",
  },

  processBgCompetency: {
    background: "#958CCB !important",
  },
  swiperStyles: {
    '& .swiper-container': {
      position: "unset !important",
      width: "100%"
    },
    '& div > .swiper-wrapper': {
      position: "unset !important"
    },
    '& div > .swiper-slide': {
      display: "flex",
      alignItems: "center"
    },
    '& div > .swiper-button-next, .swiper-button-prev': {
      "background- color": "white",
      "background- color": "rgba(255, 255, 255, 0.5)",
      right: "20px",
      padding: "12px",
      color: "#5DA196 !important",
      fill: "#5DA196 !important",
      stroke: "#5DA196 !important",
      border: "1px solid #5DA196",
      borderRadius: "3px",
      height: "20px",
      width: "20px",
      top: "150px",
    },
    '& div > .swiper-button-prev': {
      right: "60px !important",
      left: "auto !important"
    },
    '& div >.swiper-button-next:after,.swiper-button-prev:after': {
      "font-size": "12px"
    },
    '& div > .swiper-pagination, .swiper-pagination-fraction': {
      bottom: "auto",
      left: "auto",
      width: "auto",
      right: "100px",
      top: "130px",
      "font-family": "'Kanit'",
      "font-size": "14px",
      "line-height": "21px",
      "font-weight": 400,
      '& .swiper-pagination-current': {
        color: "#5DA196 !important"
      },
    },
  },

});
const styles = {
  paperContainer: {
    backgroundImage: `url(${bannerBg})`,
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    borderRadius: "10px",
    position: "relative",
  },
  bannerImage: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    maxWidth: "336px",
    height: "auto",
  },
  blueBadge: {
    background: "rgb(83 135 198 / 15%)",
    padding: "5px",
    color: "#5387C6",
  },
  blockGrid: {
    padding: "38px 0 30px 0",
    "min-height": "200px"
  },
  barLegend: {
    fontSize: "14px",
    lineHeight: "19px",
    color: "#939393",
  },
};

const HomeKPI = () => {
  const { t, i18n } = useTranslation();
  const req = useSelector((state) => state.Request);
  const stateUser = useSelector((state) => state.auth);
  const proxy = JSON.parse(localStorage.getItem("proxy"));
  const user = JSON.parse(localStorage.getItem("user"));
  const [fullFunction, setFullFunction] = React.useState(true)
  const [dataHome, setDataHome] = React.useState([]);
  const [kpiFormList, setKpiFormList] = React.useState([]);
  const [kpiFormGoal, setKpiFormGoal] = React.useState("");
  const [list, setList] = React.useState([]);
  const [valueSerial, setValueSerial] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [kpiFormSelect, setKpiFormSelect] = React.useState("");
  const [loading, setLoading] = React.useState(true)
  const [competencyData, setCompetencyData] = React.useState([])
  const [dataGoals, setDataGoals] = React.useState({
    period: {
      start: "2021-10-12",
      end: "2022-10-12"
    },
    signOffDue: "2022-11-12",
    nextAction: "Review the evaluation results with your assigned manager in 1-on1 session.",
    myGoals: [],
    myCompetencies: [],
    rb_pa_data: [
      {
        status: "draft",
        status_description: "Editing",
        submitted_date: "",
        due_date: "2022-12-05",
      },
      {
        status: "",
        status_description: "Not Started",
        submitted_date: "",
        due_date: "2022-12-05",
      },
      {
        status: "",
        status_description: "Not Started",
        submitted_date: "",
        due_date: "2022-12-31",
      },
      {
        status: "",
        status_description: "Not Started",
        submitted_date: "",
        due_date: "2022-12-31",
      },
    ]
  });
  const [summaryItems, setSummaryItems] = React.useState({
    total: 0,
    goal: 0,
    competency: 0,
    goalAndCompetency: 0,
    others: 0,
  });


  const setSummaryData = (params) => {
    const data = {
      total: params?.total ?? 0,
      goal: params?.goal ?? 0,
      competency: params?.competency ?? 0,
      goalAndCompetency: params?.goal_and_competency ?? 0,
      others: params?.others ?? 0,
    }
    setSummaryItems(data);
  }

  let chartOptions = {
    series: [
      {
        name: "Goals",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Competencies",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "GoalsAndCompetencies",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        name: "Others",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: "100px",
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      colors: ["#FA9349", "#74C1ED", "#F7B254", "#31B09B"],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 5,
          columnWidth: "40%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      grid: {
        show: false,
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      title: {
        show: false,
      },
      xaxis: {
        categories: [
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
          "MM-YY",
        ],
        labels: {
          formatter: function (val) {
            return val;
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: undefined,
        },
        tickAmount: 1,
        labels: {
          formatter: function (val) {
            return val.toFixed(0);
          }
        }
      },
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        shared: true,
        followCursor: false,
        intersect: false,
        inverseOrder: false,
        custom: undefined,
        fillSeriesColor: false,
        style: {
          fontSize: "16px",
          fontFamily: "Kanit",
          fontWeight: 300,
        },
        onDatasetHover: {
          highlightDataSeries: false,
        },
        x: {
          show: true,
          formatter: function (value, opts) {
            let total = opts.w.globals.stackedSeriesTotals[opts.dataPointIndex];
            return `${t("label.total")}: ` + Math.trunc(total);
          },
        },
        y: {
          formatter: undefined,
          title: {
            formatter: (seriesName) => t(`label.${seriesName}`) + ":",
          },
        },
        z: {
          formatter: undefined,
          title: "Size: ",
        },
        marker: {
          show: true,
        },
        items: {
          display: "flex",
        },
        fixed: {
          enabled: false,
          position: "topRight",
          offsetX: 0,
          offsetY: 0,
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
        position: "top",
        horizontalAlign: "right",
      },
    },
  };
  const [chart, setChart] = React.useState(chartOptions);

  const navigate = useNavigate();
  const [inboxType, setInboxType] = React.useState("goals");
  const [cycleType, setCycleType] = React.useState("");
  const [dataEvaluate, setDataEvaluate] = React.useState([]);
  const [achievementKpiForm, setAchievementKpiForm] = React.useState("");
  const [chartObject, setChartObject] = React.useState({
    value: [1],
    emtyData: true,
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false
    },
    tooltip: {
      enabled: false,
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
    },
    colors: ["#FA9349", "#74C1ED", "#F7B254", "#31B09B"],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
              fontSize: '12px',
              fontFamily: 'Kanit',
            },
            total: {
              show: true,
              showAlways: true,
              label: '0%',
              fontSize: '24px',
              fontFamily: 'Kanit',
              fontWeight: 600,
              color: '#5DA196',
              formatter: function (w) {
                return t('mygoal.label.complete')
              }
            },
            style: {
              fontFamily: 'Kanit',
            }
          }
        }
      }
    }
  })
  const handleButtonGroup = (_, value) => {
    if (value) setInboxType(value);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    if (kpiFormSelect == null || kpiFormSelect == '') {
      loadKpiForm()
    }
  }, [])

  useEffect(async () => {
    // getMyRequest();
    dispatch(fetchHomeDashBoard());
    await getDataHome();

    let maybeHandler = (event) => {
      if (event.target.closest(".tooltip") === null) {
        setOpen(false)
        setValueSerial("")
      }
    };

    document.addEventListener("click", maybeHandler);

    return () => {
      document.removeEventListener("click", maybeHandler);
    };
  }, [kpiFormSelect])

  useEffect(() => {
    if (kpiFormGoal && kpiFormGoal !== "") {
      dispatch(getGoalList(kpiFormGoal, 'home'))
        .then(resp => {
          if (resp.data?.kpi_form?.form_evaluate_data !== undefined && resp.data?.kpi_form?.form_evaluate_data !== null && resp.data?.kpi_form?.form_evaluate_data.length > 0) {
            const kpiForm = resp.data?.kpi_form?.form_evaluate_data !== null ? resp.data?.kpi_form?.form_evaluate_data[0] : null;
            if (kpiForm !== null) {
              var dataGoalsObject = JSON.parse(JSON.stringify(dataGoals))
              var chartColor = [];
              var mygoals = [];

              kpiForm?.my_goal_list?.goal_list.map((item) => {
                item?.goal_items.filter((goal) => {
                  mygoals.push({
                    name: goal.name,
                    weight: goal.weight + "%",
                    status: (goal?.progress_status || Object.keys(goal?.progress_status).length === 0) ? "new" : goal?.progress_status,
                    progress_status: goal?.progress_status
                  })
                })
              })

              dataGoalsObject.myGoals = mygoals

              kpiForm?.goal_progress?.more_data?.forEach((item) => {
                chartColor.push(JSON.parse(item.color).font)
              })
              var chartObjectData = { ...chartObject }
              chartObjectData.colors = chartColor;
              chartObjectData.value = kpiForm.goal_progress.Graph.data.value;
              chartObjectData.name = kpiForm.goal_progress.Graph.data.name;
              chartObjectData.total = kpiForm.goal_progress.total_goal;
              chartObjectData.emtyData = false;
              setDataGoals(dataGoalsObject)
              setChartObject(chartObjectData)
            }
          }
        })
    }
  }, [kpiFormGoal])

  const classes = useStyles();
  const handleTooltipOpen = (data) => {
    if (data !== valueSerial) {
      setOpen(true)
      setValueSerial(data)
    } else {
      setOpen(false)
      setValueSerial("")
    }
  };
  let getDataHome = async () => {
    await homeService.home().then(
      (response) => {
        if (response?.data?.rb_pa !== undefined) {
          setDataHome(response.data.rb_pa)
        }
      },
    )
    getDataCompetency(kpiFormSelect)
    getEvaluateData()
    setLoading(false)
  }

  const loadKpiForm = () => {

    dispatch(getKpiFormList("home")).then((resp) => {
      if (Util.formatData(resp, []).length > 0) {
        setCycleType(resp[0]?.options?.cycle_type)
        setAchievementKpiForm(resp[0])
        setKpiFormGoal(resp[0]?.options?.serial)
        setKpiFormSelect(resp[0]?.options?.kpi_form)
      }
    })

    // // get kpi form list for 'achievement'
    // dispatch(getKpiFormList("achievement")).then((resp) => {
    //   setKpiFormList(resp)
    //   let isDefault = resp.find((obj) => obj.is_default)
    //   if (isDefault) {
    //     // setAchievementKpiForm(isDefault ?? "")
    //     console.log(isDefault, "achievement");
    //   } else {
    //     console.log(resp?.[0], "achievement");
    //     // setAchievementKpiForm(resp?.[0] ?? "")
    //   }
    // })


    // // get kpi form list for 'goal'
    // dispatch(getKpiFormList("goal", "")).then((resp) => {
    //   let isDefault = resp.find((obj) => obj.is_default)
    //   if (isDefault) {
    //     console.log(isDefault?.options?.serial);
    //     // setKpiFormGoal(isDefault?.options?.serial, "goal", 1)
    //   } else {
    //     setKpiFormGoal(resp.length > 0 ? resp[0]?.options?.serial : "")
    //     // console.log(resp[0]?.options?.serial, "goal", 2);
    //   }
    // })

    // // get kpi form list for 'competency'
    // dispatch(getKpiFormList("competency", "")).then((resp) => {
    //   let isDefault = resp.find((obj) => obj.is_default)
    //   if (isDefault) {
    //     setKpiFormSelect(isDefault.value)
    //     // console.log(isDefault.value, "competency", 1);
    //   } else {
    //     setKpiFormSelect(resp.length > 0 ? resp[0].value : "")
    //     // console.log(resp[0].value, "competency", 2);
    //   }
    // })
  }

  let getDataAchievement = (serial) => {
    if (serial !== "") {
      dispatch(getAchievementSummary(serial)).then((resp) => {
        setSummaryData(resp?.summary)
      });
      dispatch(getAchievementList(serial)).then((resp) => {
        setList(resp?.list_achievement ?? resp)
      })
    }
  }

  const [lastestEvaluate, setLastestEvaluate] = React.useState(null)
  const [dataCustomize, setDataCustomize] = React.useState({});
  const [goalWeight, setGoalWeight] = React.useState(-1)
  const [competencyWeight, setCompetencyWeight] = React.useState(-1)

  let getEvaluateData = () => {
    const sortByDescCreatedAt = (sortData) => {
      sortData.sort(function (a, b) {
        const date1 = new Date(a.created_at)
        const date2 = new Date(b.created_at)
        return date2 - date1;
      })
      return sortData
    }
    const filterEvaluate = (list) => {
      list = list?.my_evaluate ?? list
      let evaluateList = list?.map(item => {
        let evaluate_type_status = item?.evaluate_type?.status ?? null
        if (evaluate_type_status && evaluate_type_status === "active") { //filter only active status
          return {
            serial: item?.serial ?? null,
            due_date: item?.due_date ?? null,
            evaluate_type_status: evaluate_type_status,
            evaluate_status: item?.status ?? null,
            step: item?.step ?? null,
            form: item?.form ?? null
          }
        }
      })

      // check if found "in_progress" status
      let filteredEvaluateList = evaluateList
      if (evaluateList.length > 0) {
        let tmpEvaluate = [...evaluateList].filter(item => item.evaluate_status.code === "in_progress")
        if (tmpEvaluate.length > 0) {
          filteredEvaluateList = tmpEvaluate
          filteredEvaluateList.forEach((item, index) => {
            let tmpList = item?.step?.step.filter(tmpItem => tmpItem.created_at && tmpItem.created_at !== "") //check if list has created_at
            let sortStepList = []
            if (tmpList.length > 0) {
              sortStepList = sortByDescCreatedAt(tmpList)
              filteredEvaluateList[index].sorted_date = sortStepList[0].created_at //add sorted_date field to list 
            }
          })
        } else {
          filteredEvaluateList.sort(function (a, b) {
            const date1 = new Date(a.due_date)
            const date2 = new Date(b.due_date)
            return date2 - date1;
          })
        }
      }

      return filteredEvaluateList
    }

    if (Util.formatData(kpiFormSelect, false) !== false) {
      if (cycleType === 360 || cycleType === "360") {
        evaluateService.getEvaliation360DetailWorkflow(kpiFormGoal).then((resp) => {
          if (resp?.data ?? false) {
            setLastestEvaluate(resp?.data)
          } else {
          }
        });
      } else {
        evaluateService.listMyEvaluate(kpiFormSelect).then((resp) => {
          if (resp?.data ?? false) {
            let lastestUpdateEvaluate = filterEvaluate(resp.data)
            if (lastestUpdateEvaluate.length > 0) {
              setLastestEvaluate(lastestUpdateEvaluate[0])
              if (resp?.custom) {
                setDataCustomize(resp.custom)
                if (resp?.custom?.allcomponentcategory?.components) {
                  const goal_weight = find(resp.custom.allcomponentcategory.components, { type: 'goal' })
                  if (goal_weight) setGoalWeight(goal_weight.ratio)
                  const competency_weight = find(resp.custom.allcomponentcategory.components, { type: 'competency' })
                  if (competency_weight) setCompetencyWeight(competency_weight.ratio)
                }
              }
            }
          } else {
          }
        });
      }
    }
  }

  useEffect(() => {
    i18n.language === "th-TH" ? moment.locale('th') : moment.locale('en')
    let monthRangeStart = moment()
    let monthRangeEnd = moment()
    let monthDiff = monthRangeEnd.diff(monthRangeStart, 'months')
    let currentKpiForm = achievementKpiForm

    if (currentKpiForm) {
      monthRangeStart = currentKpiForm?.start_at ?? false ? moment(currentKpiForm.start_at, 'DD-MM-YYYY') : moment()
      monthRangeEnd = currentKpiForm?.end_at ?? false ? moment(currentKpiForm.end_at, 'DD-MM-YYYY') : moment()
      monthDiff = monthRangeEnd.diff(monthRangeStart, 'months')
    }
    let initSeries = []
    const categories = [];
    let months = [];
    for (let i = 0; i <= monthDiff; i++) {
      initSeries.push(0)
      let date = monthRangeStart
      if (i === 0) {
        date.add(0, "months")
      } else {
        date.add(1, "months")
      }
      let month = date.format("MM");
      let monthName = date.format("MMM");
      let year = date.format("YYYY");

      months.push({
        monthNo: month,
        monthName: monthName,
        year: parseInt(year),
      })
      if (i18n.language === "th-TH") {
        // monthName = mapThaiMonthName(monthName)
        year = parseInt(year) + 543
      }
      categories.push(`${monthName}-${year}`);
    }
    let seriesData = {
      goals: {
        name: "Goals",
        data: [...initSeries],
      },
      competencies: {
        name: "Competencies",
        data: [...initSeries],
      },
      goalsAndCompetencies: {
        name: "GoalsAndCompetencies",
        data: [...initSeries],
      },
      others: {
        name: "Others",
        data: [...initSeries],
      },
    };
    list.forEach((item) => {
      if (item.is_link === "n") {
        months.forEach((month, index) => {
          let current = moment(`${month.year}-${month.monthNo}-01`);
          let startDate = moment(item.start_at);
          let formatStartDate = moment(
            `${startDate.format("YYYY")}-${startDate.format("MM")}-01`
          );
          let endDate = moment(item.end_at);
          let formatEndDateStart = moment(
            `${endDate.format("YYYY")}-${endDate.format("MM")}-01`
          );
          let formatEndDateEnd = moment(
            `${endDate.format("YYYY")}-${endDate.format("MM")}-28`
          );
          // if (moment(current).isBetween(formatStartDate, formatEndDate, undefined, '[]')) {
          //   seriesData.others.data[index]++
          // }
          if (
            moment(current).isBetween(
              formatEndDateStart,
              formatEndDateEnd,
              undefined,
              "[]"
            )
          ) {
            seriesData.others.data[index]++;
          }
        });
      } else {
        if (item.goal === "y" && item.competency === "n") {
          months.forEach((month, index) => {
            let current = moment(`${month.year}-${month.monthNo}-01`);
            let startDate = moment(item.start_at);
            let formatStartDate = moment(
              `${startDate.format("YYYY")}-${startDate.format("MM")}-01`
            );
            let endDate = moment(item.end_at);
            let formatEndDateStart = moment(
              `${endDate.format("YYYY")}-${endDate.format("MM")}-01`
            );
            let formatEndDateEnd = moment(
              `${endDate.format("YYYY")}-${endDate.format("MM")}-28`
            );
            // if (moment(current).isBetween(formatStartDate, formatEndDate, undefined, '[]')) {
            //   seriesData.others.data[index]++
            // }
            if (
              moment(current).isBetween(
                formatEndDateStart,
                formatEndDateEnd,
                undefined,
                "[]"
              )
            ) {
              seriesData.goals.data[index]++;
            }
          });
        } else if (item.goal === "n" && item.competency === "y") {
          months.forEach((month, index) => {
            let current = moment(`${month.year}-${month.monthNo}-01`);
            let startDate = moment(item.start_at);
            let formatStartDate = moment(
              `${startDate.format("YYYY")}-${startDate.format("MM")}-01`
            );
            let endDate = moment(item.end_at);
            let formatEndDateStart = moment(
              `${endDate.format("YYYY")}-${endDate.format("MM")}-01`
            );
            let formatEndDateEnd = moment(
              `${endDate.format("YYYY")}-${endDate.format("MM")}-28`
            );
            // if (moment(current).isBetween(formatStartDate, formatEndDate, undefined, '[]')) {
            //   seriesData.others.data[index]++
            // }
            if (
              moment(current).isBetween(
                formatEndDateStart,
                formatEndDateEnd,
                undefined,
                "[]"
              )
            ) {
              seriesData.competencies.data[index]++;
            }
          });
        } else if (item.goal === "y" && item.competency === "y") {
          months.forEach((month, index) => {
            let current = moment(`${month.year}-${month.monthNo}-01`);
            let startDate = moment(item.start_at);
            let formatStartDate = moment(
              `${startDate.format("YYYY")}-${startDate.format("MM")}-01`
            );
            let endDate = moment(item.end_at);
            let formatEndDateStart = moment(
              `${endDate.format("YYYY")}-${endDate.format("MM")}-01`
            );
            let formatEndDateEnd = moment(
              `${endDate.format("YYYY")}-${endDate.format("MM")}-28`
            );
            if (
              moment(current).isBetween(
                formatEndDateStart,
                formatEndDateEnd,
                undefined,
                "[]"
              )
            ) {
              seriesData.goalsAndCompetencies.data[index]++;
            }
          });
        }
      }
    });
    let tempChartData = {
      ...chart,
      ...{
        series: [
          seriesData.goals,
          seriesData.competencies,
          seriesData.goalsAndCompetencies,
          seriesData.others,
        ],
      },
    };
    tempChartData.options = {
      ...tempChartData.options,
      ...{
        xaxis: {
          ...tempChartData.options.xaxis,
          categories: categories,
        },
      },
    }
    setChart(tempChartData)
  }, [list])

  useEffect(() => {
    if (achievementKpiForm !== "") getDataAchievement(achievementKpiForm?.options?.cycle ?? "")
  }, [achievementKpiForm])

  let getDataCompetency = (serial) => {
    var competencyDataObject = { ...competencyData }
    let url = 'app/kpi/competency?kpi_form_id=';
    var myCompentency = [];
    // var mockupCompen = [
    //   {name: "Adaptability", type: 'Core', icon: iconCore},
    //   {name: "Team Focus", type: 'Core', icon: iconCore},
    //   {name: "Innovation", type: 'Core', icon: iconCore},
    //   {name: "Labour Law Knowledge", type: 'Functional', icon: iconFunctional},
    //   {name: "Compensation and Benefits", type: 'Functional', icon: iconFunctional},
    //   {name: "Compensation and Benefits2", type: 'Functional', icon: iconFunctional},
    // ]

    competencyService.competency(url + serial).then(
      (response) => {
        if (response?.data !== undefined && Object.keys(response.data).length > 0 && response?.data?.list) {
          Object.keys(response?.data?.list)?.map((key) => {
            response?.data?.list[key]?.map((item) => {
              myCompentency.push({
                name: item.name,
                type: item.competency_type.name,
                // icon: item.competency_type.name.indexOf('Core') > 0 ? iconCore : iconFunctional
                icon: item.competency_type?.icon ?? "",
                icon_color: item.competency_type?.color ?? ""
              })
            })
          })
          competencyDataObject.myCompetencies = myCompentency;
          setCompetencyData(competencyDataObject)
        }
      });

  }
  const dateDayFormat = (data) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
      const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
        year: '2-digit',
        month: 'short',
        day: 'numeric',
      })
      return dateTH
    }
  }
  const dateDayFormatFull = (data) => {
    if (data !== undefined && data !== null && data !== "") {
      const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
      const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
      return dateTH
    }
  }
  const formatData = (data, defaults) => {
    if (data !== null && data !== undefined && data !== "") {
      return data;
    }
    return defaults;
  }
  const seq = (data) => {
    let seqs = 0
    let order = 0
    if (data !== undefined && data !== null && data !== "null") {
      for (let index = 0; index <= data.length - 1; index++) {
        if (seqs < data[index].seq) {
          seqs = data[index].seq
          order = index
        }
      }
      return data[order]
    }
    // return {}
  }
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
      fontSize: '16px'
    },
  }));
  const clickLink = (data) => {
    navigate(data, { replace: false });
  }
  let selectName = (data) => {
    if (data !== undefined && data?.profile !== undefined) {
      let dataProfile = data?.profile
      if (i18n.language === "th-TH" && dataProfile?.options?.name_th !== undefined && dataProfile?.options?.name_th !== null && dataProfile?.options?.name_th !== "") {
        return dataProfile?.options?.name_th;
      } else if (dataProfile?.options?.name_en !== undefined && dataProfile?.options?.name_en !== null && dataProfile?.options?.name_en !== "") {
        return dataProfile?.options?.name_en;
      } else {
        return dataProfile?.fullname;
      }
    }
    return "";
  }
  let selectNameUser = (data) => {
    if (data !== undefined && data?.profile !== undefined) {
      let dataProfile = data?.profile
      if (i18n.language === "th-TH" && dataProfile?.options?.name_th !== undefined && dataProfile?.options?.name_th !== null && dataProfile?.options?.name_th !== "") {
        return dataProfile?.options?.name_th;
      } else if (dataProfile?.options?.name_en !== undefined && dataProfile?.options?.name_en !== null && dataProfile?.options?.name_en !== "") {
        return dataProfile?.options?.name_en;
      } else {
        return dataProfile?.firstname + ` ` + dataProfile?.lastname
      }
    }
    return "";
  }

  return (
    <>
      <Helmet>
        <title>HOME | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} xs={12}>
              <Box mt={6} width="100%">
                <Paper style={styles.paperContainer}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      lg={4}
                      xs={4}
                      style={{ position: "relative" }}
                    >
                      <img
                        src={bannerImg}
                        alt="bannerImage"
                        style={styles.bannerImage}
                      />
                    </Grid>
                    <Grid item lg={8} xs={8} style={styles.blockGrid} sx={{ position: "relative" }}>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Typography fontSize={14} lineHeight="15.4px" color="#404349">
                            {/*{t("home.label.banner.hello")} Mr.PMS{" "}*/}
                            {t('home.label.hello')} {proxy?.proxy_token !== undefined ? selectName(proxy) : selectNameUser(user)}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Typography
                            fontSize={36}
                            lineHeight="39.6px"
                            sx={{ paddingTop: "11px", fontWeight: "600", color: "#404349" }}
                          >
                            {/*{t("home.label.banner.welcome-to-pms")}*/}
                            {t('home.label.welcome')}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Box sx={{ position: "absolute", bottom: "21px", right: "21px", display: "flex", alignItems: "Center", justifyContent: "space-between" }} >
                        <Button className={classes.processBgGoals} sx={{ "border-radius": '22px', minWidth: '82px', marginRight: '16px', padding: "15px", display: "flex", flexDirection: "row", alignItems: "Center", cursor: 'pointer' }} onClick={() => navigate("/kpi/manual/listbooks", { replace: false })}>

                          <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="20px" fontWeight={600} color="#FFFFFF">
                            {t("handbook.label.handbook")}
                          </Typography>

                          <img src={iconNext} style={{ maxWidth: '28px', maxHeight: '20px', marginLeft: '8px' }}>

                          </img>
                        </Button>

                      </Box>

                      {dataHome?.length > 0 ?
                        dataHome?.map((loRow, index) => (
                          loRow?.rb_pa_data.length >= 0 ?
                            <Grid key={index} container spacing={1}>
                              <Grid item>
                                {
                                  i18n.language === "en-US" ?
                                    (
                                      <Typography
                                        fontSize={18}
                                        lineHeight="27px"
                                        sx={{ paddingTop: "10px", maxWidth: "860px" }}
                                      >
                                        {t("home.label.announceText1")}
                                        <span className={classes.styleText}>
                                          {t("home.label.announceText2")}
                                        </span>{" "}
                                        {t("home.label.announceText3")} <span className={classes.styleText}>{loRow?.rb_pa_data.length > 0 ? `${dateDayFormatFull(seq(loRow?.rb_pa_data)?.before)}` : "-"}</span>
                                      </Typography>
                                    ) : (
                                      <Typography
                                        fontSize={18}
                                        lineHeight="27px"
                                        sx={{ paddingTop: "10px", maxWidth: "860px" }}
                                      >
                                        {t("home.label.announceText1")}
                                        <span className={classes.styleText}>
                                          {t("home.label.announceText2")}
                                        </span>{" "}
                                        {t("home.label.announceText3")} <span className={classes.styleText}>วันที่ {loRow?.rb_pa_data.length > 0 ? `${dateDayFormatFull(seq(loRow?.rb_pa_data)?.before)}` : "-"}</span>
                                      </Typography>
                                    )
                                }
                              </Grid>
                            </Grid>
                            : null
                        ))
                        : null}
                    </Grid>
                  </Grid>
                </Paper>
              </Box>
            </Grid>
            <Announcement />
            <Grid sx={{ width: "100%", ml: "16px", my: 1 }}>
              <Divider />
            </Grid>
          </Grid>
          {(Object.keys(dataGoals).length > 0 && !loading) ?
            <Box mt={1}>
              <Grid container item pb={2} pt={2}>
                <Grid item xs sm md lg sx={{ height: 1 }}>
                  <Card sx={{ height: 1, overflow: "unset" }}>
                    <CardContent sx={{ px: 2 }} style={{ "padding-bottom": "20px" }}>
                      <Grid container spacing={0} justifyContent="space-between">
                        <Grid item sx={{ display: "flex", "align-items": "center" }}>
                          <div
                            className={`${classes.iconContainer}`}
                            style={{ background: "#5DA196" }}
                          >
                            <img src={overview} alt="bannerImage" />
                          </div>
                          <Typography
                            fontSize={24}
                            ml="15px"
                            lineHeight="22px"
                            sx={{ fontWeight: "600" }}
                            color="#404349"
                          >
                            {t("label.overviewAndAchievement")}
                          </Typography>
                        </Grid>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <Box mt="4px">
                            {fullFunction ?
                              <BootstrapTooltip title={t('home.label.viewAchievements')} placement="top" onClick={() => clickLink('/kpi/achievement')}>
                                <KpiArrow style={{ cursor: "pointer" }} />
                              </BootstrapTooltip>
                              : null
                            }
                          </Box>
                        </Box>
                      </Grid>
                      <Grid sx={{ width: "100%", "padding-top": "16px" }}>
                        <Divider />
                      </Grid>
                      <Grid container spacing={4}>
                        <Grid item xs={12} display="flex">
                          <Grid item sx={{ minWidth: "450px", width: "35%" }} >
                            {Object.keys(chartObject).length > 0 && chartObject?.emtyData === true ?
                              <Box sx={{ height: "100%" }} p="18px 0 0 0">
                                <Typography fontSize={18} lineHeight="26.4px" fontWeight={500} color="#404349" sx={{ textAlign: "left" }}>
                                  {t("mygoal.label.goalProgress")}
                                </Typography>
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100% - 27px)" }}>
                                  <Box>
                                    <Box>
                                      <img src={fileBrowser} alt="browser" />
                                    </Box>
                                    <Typography sx={{ color: "#939393", textAlign: "center" }}>
                                      {t('label.nodata')}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                              :
                              <GoalsStatusWithEmpty datas={chartObject} />
                            }
                          </Grid>
                          {Object.keys(chart).length > 0 &&
                            <Grid item sx={{ width: "65%" }}>
                              <MyAchievements chart={chart} total={summaryItems.total} />
                              {/* summaryItems.total */}
                            </Grid>
                          }
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container my={2}>
                <Grid item xs sm md lg sx={{ height: 1 }}>
                  <Card sx={{ height: 1, overflow: "unset" }}>
                    <CardContent sx={{ px: 2, position: "relative" }}>
                      <Grid container spacing={0} justifyContent="space-between">
                        <Grid item sx={{ display: "flex", "align-items": "center" }}>
                          <div
                            className={`${classes.iconContainer}`}
                            style={{ background: "#5DA196" }}
                          >
                            <img src={file} alt="bannerImage" />
                          </div>
                          <Box item>
                            <Typography
                              fontSize={24}
                              ml="15px"
                              lineHeight="22px"
                              sx={{ fontWeight: "600" }}
                              color="#404349"
                            >
                              {t("label.performanceEvaluationOverview")}
                            </Typography>
                          </Box>
                        </Grid>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <Box mt="4px">
                            {true ?//fullFunction ?
                              <BootstrapTooltip title={t('home.label.viewEvaluation')} placement="top" onClick={() => clickLink('/kpi/evaluation')}>
                                <KpiArrow style={{ cursor: "pointer" }} />
                              </BootstrapTooltip>
                              : null
                            }
                          </Box>
                        </Box>
                      </Grid>
                      <Grid sx={{ width: "100%", "padding-top": "16px" }}>
                        <Divider />
                      </Grid>
                      {lastestEvaluate &&
                        <Grid sx={{ width: "100%", "padding-top": "15px", display: "flex", alignItems: "center" }}>
                          <CalendarIcon color="#404349" /> <Typography fontSize={18} lineHeight="20px" sx={{ fontWeight: "400" }} ml="12px" color="#404349"> {t("evaluation.evaluationCycle")}: {`${Util.dateMonthFormatAdmin(lastestEvaluate?.form?.start_date)} - ${Util.dateMonthFormatAdmin(lastestEvaluate?.form?.end_date)}`}</Typography>
                        </Grid>
                      }
                      {lastestEvaluate &&
                        <Grid sx={{ width: "100%", "padding-top": "20px", "padding-bottom": "19px", display: "flex", alignItems: "center" }}>
                          <CalendarIcon color="#404349" /> <Typography fontSize={18} lineHeight="20px" sx={{ fontWeight: "400" }} ml="12px" color="#404349"> {t("evaluation.signOffDueDate")}: {Util.formatData(lastestEvaluate?.due_date, false) !== false ? `${Util.formatDate4(lastestEvaluate?.due_date)}` : "-"}</Typography>
                        </Grid>
                      }
                      {lastestEvaluate &&
                        <Grid container mt={2}>
                          <Grid item xs={12} display="flex" className={classes.swiperStyles}>
                            {lastestEvaluate?.step?.step !== undefined && lastestEvaluate?.step?.step !== null && lastestEvaluate?.step?.step.length > 0 ?
                              <Swiper
                                slidesPerView={4}
                                slidesPerGroup={4}
                                loop={false}
                                pagination={{
                                  clickable: true,
                                  type: "fraction"
                                }}
                                navigation={true}
                                modules={[Pagination, Navigation]}
                                className="mySwiper"
                              >
                                <Box sx={{ width: "100%", display: "flex", alignItems: "center", }}>
                                  {lastestEvaluate?.step?.step?.map((loRow, index) => (
                                    <SwiperSlide>
                                      <>
                                        <div
                                          style={{
                                            // maxWidth: "235px",
                                            width: "100%",
                                            height: "100%",
                                            background:
                                              loRow?.is_current === true && loRow?.status === "approve" ?
                                                "#5DA1961A"
                                                : loRow?.is_current === true ?
                                                  "#F7B2541A"
                                                  : loRow?.status === "approve" ?
                                                    "#5DA1961A"
                                                    : loRow?.status === "wait" ?
                                                      "#FFFFFF"
                                                      : "#FFFFFF",
                                            border:
                                              loRow?.is_current === true && loRow?.status === "approve" ?
                                                "1px solid #5DA196"
                                                : loRow?.is_current === true ?
                                                  "1px solid #F7B254"
                                                  : loRow?.status === "approve" ?
                                                    "1px solid #5DA196"
                                                    : loRow?.status === "wait" ?
                                                      "1px solid #DADADA"
                                                      : "1px solid #DADADA",
                                            borderRadius: "5px",
                                            position: "relative",
                                            // paddingBottom: "25px"

                                          }}
                                        >
                                          <Box
                                            sx={{ p: 1, display: "flex", alignItems: "start" }}
                                          >
                                            <Box
                                              mt="4px"
                                              style={{
                                                background:
                                                  loRow?.is_current === true && loRow?.status === "approve" ?
                                                    "#5DA196"
                                                    : loRow?.is_current === true ?
                                                      "#F7B254"
                                                      : loRow?.status === "approve" ?
                                                        "#5DA196"

                                                        : loRow?.status === "wait" ?
                                                          "#FAFAFA" : "#FAFAFA",
                                                border:
                                                  loRow?.is_current === true || loRow?.status === "approve" ?
                                                    "none" : "1px dashed #C4C4C4",
                                                borderRadius: "50%",
                                                width: "30px",
                                                height: "30px",
                                              }}
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              {/* <CheckIcon></CheckIcon> */}
                                              {
                                                loRow?.is_current === true && loRow?.status === "approve" ?
                                                  <ApprovedIcon></ApprovedIcon>
                                                  : loRow?.is_current === true ?
                                                    <DraftIcon></DraftIcon>
                                                    : loRow?.status === "approve" ?
                                                      <ApprovedIcon></ApprovedIcon>

                                                      : null
                                              }
                                            </Box>
                                            <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                              <Typography fontSize="18" fontWeight="600"
                                                sx={{
                                                  color:
                                                    loRow?.is_current === true ||
                                                      loRow?.status === "approve" ?
                                                      "#404349"
                                                      : "#C4C4C4"
                                                }}
                                              >
                                                {loRow?.name}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box
                                            sx={{
                                              px: 1,
                                              paddingRight: "0px",
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            {cycleType === 360 || cycleType === "360" ?
                                              loRow?.type !== "evaluate" ?
                                                <Box sx={{ paddingLeft: "30px", ml: 2, display: "flex", alignItems: "baseline", width: "100%", }}>
                                                  <Typography variant="h6" fontWeight="400"
                                                    sx={{
                                                      color:
                                                        loRow?.is_current === true ||
                                                          loRow?.status === "approve" ?
                                                          "#404349"
                                                          : "#C4C4C4"
                                                    }}>
                                                    {t('label.by')}<span>&nbsp;</span>
                                                  </Typography>
                                                  <Box sx={{ width: "100%", }}>
                                                    {loRow?.options?.assignee !== undefined && loRow?.options?.assignee !== null && loRow?.options?.assignee.length > 0 ?
                                                      loRow?.options?.assignee.map((item) => (
                                                        <Box sx={{ width: "calc(100% - 44px)", display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative", }}>
                                                          <Typography variant="h6" fontWeight="400"
                                                            sx={{
                                                              width: item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ? "calc(100% - 25px)" : "calc(100% - 10px)",
                                                              textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap",
                                                              color:
                                                                loRow?.is_current === true ||
                                                                  loRow?.status === "approve" ?
                                                                  "#404349"
                                                                  : "#C4C4C4"
                                                            }}>
                                                            {item.assignee}
                                                          </Typography>
                                                          {item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ?
                                                            <Box style={{ position: "absolute", right: 0, top: 0, margin: "2px 6px 6px 0px", }}>
                                                              <div style={{ width: "max-content" }}>
                                                                <BootstrapTooltip
                                                                  placement="top"
                                                                  arrow
                                                                  title={t('label.proxyBy') + "" + Util.formatData(item?.proxy_by, "-")}
                                                                >
                                                                  <InfoIcon style={{ cursor: "pointer" }} />
                                                                </BootstrapTooltip>
                                                                {/* <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                              </div>
                                                            </Box> : null}
                                                        </Box>
                                                      ))
                                                      :
                                                      <Typography variant="h6" fontWeight="400"
                                                        sx={{
                                                          color:
                                                            loRow?.is_current === true ||
                                                              loRow?.status === "approve" ?
                                                              "#404349"
                                                              : "#C4C4C4"
                                                        }}>
                                                        {"-"}
                                                      </Typography>
                                                    }
                                                  </Box>
                                                </Box>
                                                : null
                                              :
                                              <Box sx={{ paddingLeft: "30px", ml: 2, display: "flex", alignItems: "baseline", width: "100%", }}>
                                                <Typography variant="h6" fontWeight="400"
                                                  sx={{
                                                    color:
                                                      loRow?.is_current === true ||
                                                        loRow?.status === "approve" ?
                                                        "#404349"
                                                        : "#C4C4C4"
                                                  }}>
                                                  {t('label.by')}<span>&nbsp;</span>
                                                </Typography>
                                                <Box sx={{ width: "100%", }}>
                                                  {loRow?.options?.assignee !== undefined && loRow?.options?.assignee !== null && loRow?.options?.assignee.length > 0 ?
                                                    loRow?.options?.assignee.map((item) => (
                                                      <Box sx={{ width: "calc(100% - 44px)", display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative", }}>
                                                        <Typography variant="h6" fontWeight="400"
                                                          sx={{
                                                            width: item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ? "calc(100% - 25px)" : "calc(100% - 10px)",
                                                            textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap",
                                                            color:
                                                              loRow?.is_current === true ||
                                                                loRow?.status === "approve" ?
                                                                "#404349"
                                                                : "#C4C4C4"
                                                          }}>
                                                          {item.assignee}
                                                        </Typography>
                                                        {item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ?
                                                          <Box style={{ position: "absolute", right: 0, top: 0, margin: "2px 6px 6px 0px", }}>
                                                            <div style={{ width: "max-content" }}>
                                                              <BootstrapTooltip
                                                                placement="top"
                                                                arrow
                                                                title={t('label.proxyBy') + "" + Util.formatData(item?.proxy_by, "-")}
                                                              >
                                                                <InfoIcon style={{ cursor: "pointer" }} />
                                                              </BootstrapTooltip>
                                                              {/* <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                            </div>
                                                          </Box> : null}
                                                      </Box>
                                                    ))
                                                    :
                                                    <Typography variant="h6" fontWeight="400"
                                                      sx={{
                                                        color:
                                                          loRow?.is_current === true ||
                                                            loRow?.status === "approve" ?
                                                            "#404349"
                                                            : "#C4C4C4"
                                                      }}>
                                                      {"-"}
                                                    </Typography>
                                                  }
                                                </Box>
                                              </Box>
                                            }
                                          </Box>
                                          <Box
                                            sx={{
                                              px: 1,
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                              <Typography variant="h6" fontWeight="400"
                                                sx={{
                                                  color:
                                                    loRow?.is_current === true ||
                                                      loRow?.status === "approve" ?
                                                      "#404349"
                                                      : "#C4C4C4"
                                                }}>
                                                {/* {t('label.formStatus')}: {formatData(loRow?.status, "Not Started")} */}
                                                {t('label.formStatus')}: {loRow?.is_current === true && loRow?.status === "approve" ? t('label.completed') : loRow?.is_current === true ? t('label.inProgress') : loRow?.status === "approve" ? t('label.completed') : t('label.notStarted')}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box
                                            sx={{
                                              px: 1,
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                              <Typography variant="h6" fontWeight="400"
                                                sx={{
                                                  color:
                                                    loRow?.is_current === true ||
                                                      loRow?.status === "approve" ?
                                                      "#404349"
                                                      : "#C4C4C4"
                                                }}>
                                                {t('evaluation.submittedDate')}: {formatData(dateDayFormat(loRow?.update_at), "-")}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          {/* {formatData(loRow?.start_date, false) !== false ?
                                            <Box
                                              sx={{
                                                px: 1,
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                <Typography variant="h6" fontWeight="400"
                                                  sx={{
                                                    color:
                                                      loRow?.is_current === true ||
                                                        loRow?.status === "approve" ?
                                                        "#404349"
                                                        : "#C4C4C4"
                                                  }}>
                                                  {t('evaluation.startDate')}: {formatData(dateDayFormat(loRow?.start_date), "-")}
                                                </Typography>
                                              </Box>
                                            </Box>
                                            : null} */}
                                          <Box
                                            sx={{
                                              px: 1,
                                              pb: 1,
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                              <Typography variant="h6" fontWeight="400"
                                                sx={{
                                                  color:
                                                    loRow?.is_current === true ||
                                                      loRow?.status === "approve" ?
                                                      "#404349"
                                                      : "#C4C4C4"
                                                }}>
                                                {t('evaluation.dueDate')}: {formatData(dateDayFormat(loRow?.end_date), "-")}
                                              </Typography>
                                            </Box>
                                          </Box>
                                          <Box
                                            style={{
                                              position: "absolute",
                                              right: 0,
                                              top: 0,
                                              margin: 6,
                                            }}
                                          >
                                            <div style={{ width: "max-content" }}>
                                              <BootstrapTooltip
                                                placement="top"
                                                arrow
                                                title={formatData(loRow?.tooltip, "-")}
                                              >
                                                <InfoIcon style={{ cursor: "pointer" }} />
                                              </BootstrapTooltip>
                                              {/* <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                            </div>
                                          </Box>
                                        </div>
                                        {/* connector */}
                                        <Box
                                          id="connector"
                                          sx={{
                                            borderTop: lastestEvaluate?.step?.step.length === index + 1 ? "" : "3px dashed #E5E5E5",
                                            width: "100%",
                                            maxWidth: "65px",
                                            // "&:last-child": {
                                            //     borderTop: "none",
                                            //     width: "0px"
                                            // }
                                          }}
                                        ></Box>
                                      </>
                                    </SwiperSlide>
                                  ))}
                                </Box>
                              </Swiper>
                              : null
                            }
                          </Grid>
                          {/* {dataGoals.rb_pa_data !== undefined && dataGoals?.rb_pa_data !== null ?
                            <Grid item xs={12} display="flex" pt="15px !important" sx={{ "svg": { width: "18px", height: "18px" } }}>
                              <InfoIcon />
                              <Typography ml="12px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "400" }} >Next action: </Typography>
                              <Typography ml="5px" color="#A3A3A3" fontSize={16} lineHeight={1.1} sx={{ fontWeight: "300" }} >Evaluator review the evaluation.</Typography>
                            </Grid>
                            : null
                          } */}
                        </Grid>
                      }
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {dataCustomize?.allcomponentcategory?.evalutation_ratio &&
                <Grid container spacing={2} mt={1}>
                  <Grid item lg={6} md={6} xs={12}>
                    <Card sx={{ height: 1, "box-shadow": "0px 0px 4px rgba(0, 0, 0, 0.1)", "border-radius": "5px" }} >
                      <EvaluationRatio datas={dataCustomize?.allcomponentcategory?.evalutation_ratio} title={t('evaluation.evaluationRatio')} />
                    </Card>
                  </Grid>
                </Grid>
              }

              <Grid container spacing={2} mt={1}>
                <Grid item lg={6} md={6} xs={12}>
                  <DashboardMyGoals icon={myGoals} title={t("label.myGoals")} data={dataGoals.myGoals} weight={goalWeight} />
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                  <DashboardMyCompetencies icon={myCompetencies} title={t("label.myCompetencies")} data={competencyData?.myCompetencies?.length > 0 ? competencyData.myCompetencies : []} fullFunction={fullFunction} weight={competencyWeight} />
                </Grid>
              </Grid>
              <Grid sx={{ width: "100%", "padding-top": "30px", "padding-bottom": "30px" }}>
                <Divider />
              </Grid>
            </Box >
            :
            null
          }
          <Inbox fullFunction={fullFunction} />
        </Container >
      </Box >
    </>
  );
};
export default HomeKPI;
